// @flow

import { useMemo } from 'react';

import type { ImageToWebPFragment, OtherImageFragment } from 'graphql-types';

export type Images = ImageToWebPFragment | OtherImageFragment;

type ImageQuery = {
  edges: {
    node: Images,
  }[],
};

export type AllImages = { imageToWebP?: ImageQuery, otherImage?: ImageQuery };

const IMAGE_TYPES = ['imageToWebP', 'otherImage'];

// $FlowFixMe
const returnImages = (images: ImageQuery) => images.edges.reduce((obj, { node }) => ({ ...obj, ...{ [node.name]: node } }), {});

const useImages = (queries: AllImages): ((key: string) => Images) =>
  useMemo(() => {
    const images = IMAGE_TYPES.reduce((obj, key) => (queries[key] ? { ...obj, ...returnImages(queries[key]) } : obj), {});
    return (key, suppressError = false) => {
      if (images[key]) return images[key];
      if (!suppressError) throw new Error(`Image with name ${key} was not found.`);
      else return null;
    };
  }, [queries]);

export default useImages;
